import { SalesKpisDTO } from '../dto/SalesKpisDTO';
import { SalesKpis } from '@domain/sales/models/SalesKpis';

export class SalesKpisMapper {
  static toModel(dto: SalesKpisDTO): SalesKpis {
    return {
      totalQuantity: dto.totalQuantity,
      previousTotalQuantity: dto.previousTotalQuantity,
      changePercent: dto.changePercent,
      range: dto.range,
      weeks: dto.weeks,
    };
  }
}
